module.exports = __webpack_public_path__ + "img/37.785a262b.jpg";